import {
  getSearchValueByKey,
  getItem,
  timeFormat,
  isWebPlatform,
  isCubePlatform,
  isWxPlatform,
  getCombineRole
} from '@/utils/comUtils'
import {
  mcSetMenu,
  mcSetRight,
  mcOpenLink,
  mcHidePreloader
} from '@/utils/mcSdkUtils'
import { h5Host, appId } from '@/env'
import { LEAVE_ROLE, TAB_ROLE_ID, PAGE_IN_MODULE } from '@/utils/constUtils'
import { mapGetters, mapState } from 'vuex'
import moduleRole from '@/store/role'
import API from '@/api'
export default {
  components: {},
  props: {},
  data() {
    return {
      showReasonDialog: false,
      isZjCube: isCubePlatform(),
      h5Host, // 微应用地址
      appId: appId[getSearchValueByKey('platformSource') || '1'], // 微应用Id
      corpId: getSearchValueByKey('corpId'), // 钉钉机构ID
      // 注意：以下参数仅在免登过后才可使用，即（token页不可使用，请直接使用this.$store.getters.xxxx）
      platformSource: getSearchValueByKey('platformSource') || '1',
      orgId: (this.$store.getters.token || {}).orgId, // orgId
      corpName: (this.$store.getters.token || {}).orgName, // 钉钉机构名
      dingUserId: (this.$store.getters.token || {}).userid || '',
      dingUserName: (this.$store.getters.token || {}).userName || '',
      orgUserId: (this.$store.getters.token || {}).orgUserId || '',
      isGray: getItem('isgray'), // 灰度还是全量
      noLimitFlag: this.$store.getters.noLimitFlag, // 到离校门禁不限制通行
      passCount: this.$store.getters.passCount, // 到离校门禁限制通行时的通行次数
      permitDevices: this.$store.getters.permitDevices, // 到离校门禁设备
      afterschoolHeaderMasterDevices:
        this.$store.getters.afterschoolHeaderMasterDevices, // 班主任刷脸设备
      commonConfigId: this.$store.getters.commonConfigId, // 配置id
      campusId:
        getItem('currentCapmusId') ||
        (this.$store.getters.currentCapmus || {}).tpId ||
        '', // 校区ID
      campusClassic: (this.$store.getters.currentCapmus || {}).classic ? 1 : 0, // 校区ID 1经典 0自定义
      studentDetail: this.$store.getters.studentDetail || {}, // 校区ID
      currentMixinRoleIsAdmin:
        +LEAVE_ROLE.admin === +(getItem(TAB_ROLE_ID) || {}).role,
      currentMixinRoleIsCustom:
        +LEAVE_ROLE.customRole === +(getItem(TAB_ROLE_ID) || {}).role,
      currentMixinRole: +((getItem(TAB_ROLE_ID) || {}).role || 0), // 当前tab下的角色
      rightTime: 500, // 设置右上角菜单延迟
      wxOpenId: (this.$store.getters.token || {}).openId || '',
      isWxPlatform: isWxPlatform()
    }
  },
  computed: {
    // 定义在 store/role.js 中的角色变量
    ...mapState(Object.keys(moduleRole.state)),
    ...mapGetters(Object.keys(moduleRole.getters)),
    // 当前学期是否结束
    isSchoolTermEnd() {
      const currentDay = timeFormat(new Date(), 'YYYYMMDD')
      const { termEndDimDay } = this.$store.getters.semesterSetting
      return currentDay > termEndDimDay
    },
    commonParams() {
      return {
        campusId: this.campusId,
        operUserRoleTypes:
          (this.$route.meta || {}).modular === PAGE_IN_MODULE.security
            ? getCombineRole(this.currentRole, 'security')
            : this.currentRole
      }
    },
    commonParams2() {
      return {
        campusId: this.campusId,
        operUserRoleTypes: this.roleIdList.join(',')
      }
    },
    commonTerm() {
      return {
        schoolYear: this.$store.getters.semesterSetting.schoolYear,
        schoolTermOrder: +this.$store.getters.semesterSetting.termOrder
      }
    },
    // 调代课-是否能进行调/代课
    isAbleSubstitute() {
      return this.isAdmin || this.isHeadmaster || this.isClassTeacher
    },
    currentStudent() {
      return (
        this.$store.getters.studentList.find(item => {
          return item.memberId + '' === this.$store.getters.studentNumber + ''
        }) || this.$store.getters.studentList[0]
      )
    },
    cpCurrentStudent() {
      let studentDetail = {}
      if (this.$store.getters.studentNumber) {
        const student = this.$store.getters.studentList.find(
          item => item.memberId === this.$store.getters.studentNumber
        )
        studentDetail = {
          ...student,
          userId: student.tpId,
          userName: student.name,
          avator: student.avatarImage,
          deptName: student.className,
          dormTag: student.accommodationTagName
        }
      }
      return studentDetail
    }
  },
  watch: {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {
    setTimeout(() => {
      this.handlerCommonSetRight()
      mcSetMenu({ items: [] })
    })
  },
  destroyed() {},
  methods: {
    async getLeaveList() {
      let _leaveType = null
      const _leaveTypeGroup =
        (await API.getLeaveTypeGroup(this.commonParams)) || {}
      let _leaveTypeList =
        (_leaveTypeGroup.defaultLeaveTypeList || []).concat(
          _leaveTypeGroup.customLeaveTypeList || []
        ) || []
      _leaveType = {}
      _leaveTypeList.forEach(item => {
        _leaveType[item.leaveType] = item.leaveTypeName
      })
      return _leaveType
    },
    showReason() {
      // this.showReasonDialog = true
      // let _that = this
      API.getCampusOrgInfo({ orgId: this.orgId })
        .then(res => {
          if (res && res.result && res.result !== '0') {
            return false
          }
          if (res) {
            let address = ''
            if (res.provinceStr) {
              address = res.provinceStr
              if (res.cityStr) {
                address += '-' + res.cityStr
              }
            }
            let $dialog = this.$Dialog(
              {
                title: '系统提示',
                content: '',
                $events: {
                  confirm() {
                    $dialog && $dialog.hide()
                  }
                }
              },
              createElement => {
                return [
                  createElement(
                    'div',
                    {
                      slot: 'content'
                    },
                    [
                      createElement(
                        'p',
                        {
                          class: '',
                          on: {
                            click: () => {}
                          }
                        },
                        [`机构所属地区：${address}，当前设备无法在该地区使用；`]
                      ),
                      createElement(
                        'p',
                        {
                          class: '',
                          on: {
                            click: () => {}
                          }
                        },
                        [
                          '如机构所在地区有误，点击',
                          createElement(
                            'span',
                            {
                              class: 'c-006AFE',
                              on: {
                                click: () => {
                                  this.openCsLink()
                                }
                              }
                            },
                            ['联系客服人员']
                          ),
                          '修改；'
                        ]
                      ),
                      createElement(
                        'p',
                        {
                          class: '',
                          on: {
                            click: () => {}
                          }
                        },
                        ['如设备使用地区不符，请联系当地销售人员。']
                      )
                    ]
                  )
                ]
              }
            ).show()
          }
        })
        .catch(err => {
          console.log('unhandledrejection', err)
        })
    },
    reasonConfirm() {},
    openCsLink() {
      if (this.isZjCube) {
        window.open(
          'dingtalk://dingtalkclient/page/link?pc_slide=true&url=https%3A%2F%2Fn.dingtalk.com%2Fdingding%2Fpublic-service-group%2Fjoin-group-code%2Findex.html%3FcorpId%3Ddingd716f501650fbc6c35c2f4657eb6378f%26teamId%3D807003%26joinGroupCode%3Dp3cAnJVnxMPO25P9SiicW0oCbgVFL1g39RcoanREIiS8WXXJbnLgiiSKPtGpTvSFs9Z'
        )
      } else {
        window.open(
          'dingtalk://dingtalkclient/page/link?pc_slide=true&url=https%3A%2F%2Fh5.dingtalk.com%2Fservice-group%2Findex.html%3FjoinGroupCode%3Dp3cAnJVnxMPO25P9SiicW0gn2rdjnmFJLpI77eCEPo6MiS5ZHAA1IUiimqLrANZgjfK%23%2Fjoin-group'
        )
      }
    },
    handlerCommonSetLeft() {},
    // 设置钉钉右侧按钮
    handlerCommonSetRight({
      text = '',
      path = '',
      control = false,
      show = false,
      handle = () => {}
    } = {}) {
      if (isWebPlatform()) {
        this.$root.$children[0].rightMenu = [{ name: text, value: path }]
      } else {
        mcSetRight({
          control,
          show,
          text,
          handle
        })
      }
    },
    /**
     * 设置钉钉导航栏右侧菜单
     */
    handlerCommonSetRightMenu(
      buttonName = [],
      routes = [],
      urls = [],
      linkType = [0, 0, 0, 0, 0, 0, 0, 0], // 0: 站内 1: 站外 2: 事件
      t
    ) {
      const _items =
        (buttonName.length &&
          buttonName.map((res, index) => {
            const _res = {
              id: `${index + 1}`,
              text: res
            }
            if (urls[index]) {
              _res.url = urls[index]
            }
            return _res
          })) ||
        []
      _items.forEach(menu => {
        menu.name = menu.text
        menu.value = menu.id
      })
      const menuObj = {
        backgroundColor: '#FFFFFF',
        textColor: '#006AFE',
        items: _items
      }
      isWebPlatform() && (this.$root.$children[0].rightMenu = _items)
      mcSetMenu(menuObj)
        .then(menu => {
          let _id = Math.max(menu.id - 1, 0)
          switch (`${linkType[_id]}`) {
            case '0':
              this.$router.push(routes[_id])
              break
            case '1':
              mcOpenLink({ url: routes[_id] })
              break
            case '2':
              t[routes[_id].callback](routes[_id].query)
              break
            case '3':
              this.$router.push({
                path: '/banner-iframe',
                query: {
                  url: routes[_id]
                }
              })
              break
            default:
              break
          }
        })
        .catch(() => {})
        .finally(() => {})
    },
    /**
     * 同意设置路由跳转
     */
    mixinRouter(path = '', query = {}) {
      this.$router.push({ path: path, query: query })
    },
    // 页面所需API
    getApi(api, params, hasCommonParams = false) {
      return new Promise((resolve, reject) => {
        let _params = {
          ...params
        }
        if (hasCommonParams) {
          _params = { ...this.commonParams, ...params }
        }
        API[api](_params)
          .then(res => {
            if (res && res.result && res.result !== '0') {
              mcHidePreloader()
              return false
            }
            resolve(res)
          })
          .catch(err => {
            console.log(err)
            reject(err)
          })
      })
    },
    calculateStudentImage(data) {
      data.forEach(student => {
        // 0 未知  1 男  2 女
        // 不能直接 require , 使用 class 控制
        student.imgClass = `avator${student.gender}-1`
      })
      return data
    },
    hasError(res) {
      return res && res.result && res.result !== '0'
    }
  }
}
